/**
 * FdaDisclaimer — prominent, reusable FDA "not evaluated" warning.
 *
 * Surfaces the two compliance statements the storefront must carry on every
 * product context: (1) the FDA has not evaluated or approved these products,
 * and (2) no therapeutic / medical / health claims are made about them.
 *
 * variant:
 *   'card'   — full amber callout box (default; product & landing pages)
 *   'inline' — slim single-line note (tight spaces, e.g. cart summary)
 */
export default function FdaDisclaimer({ variant = 'card', className = '' }) {
  if (variant === 'inline') {
    return (
      <p className={`text-[11px] leading-relaxed text-amber-700 ${className}`}>
        <strong>FDA notice:</strong> These products have not been evaluated by the
        U.S. Food and Drug Administration and are not intended to diagnose, treat,
        cure, or prevent any disease. No health claims are made.
      </p>
    );
  }

  return (
    <div
      role="note"
      aria-label="FDA disclaimer"
      className={`rounded-xl border border-amber-200 bg-amber-50 p-4 ${className}`}
    >
      <div className="flex gap-3">
        <span className="text-xl shrink-0 leading-none" aria-hidden="true">⚠️</span>
        <div className="text-[13px] leading-relaxed text-amber-900">
          <p className="font-bold uppercase tracking-wide text-amber-800 mb-1">
            FDA has not reviewed these products
          </p>
          <p>
            These products have not been evaluated or approved by the U.S. Food and
            Drug Administration (FDA). They are sold strictly for laboratory and
            in-vitro research use only and are <strong>not intended to diagnose,
            treat, cure, or prevent any disease</strong>. Aloha Amino makes no
            therapeutic, medical, or health claims about these products.
          </p>
        </div>
      </div>
    </div>
  );
}
